import { useContext, useMemo, useState } from 'react';
import { Box, Tooltip } from '@mui/material';
import CompGroupContext from 'context/CompGroupContext';
import CompGroupsDialog from 'pages/Valuations/components/CompGroups/components/CompGroupsDialog';
import { generateColorFromString, getInitials } from 'utilities';
import { Root } from './CompGroupLabel.styles';
import { CompGroupLabelProps } from './CompGroupLabel.types';
import { compGroupLabelClasses } from './constants';
import getCompGroupTooltipContent from './getCompGroupTooltipContent';

const CompGroupLabel = ({ compGroupData, setCompanyInfoHovering }: CompGroupLabelProps) => {
  const [openCompGroupsDialog, setOpenCompGroupsDialog] = useState<boolean>(false);
  const { saveCompGroups, deleteCompGroup, tableData, approachType } = useContext(CompGroupContext);
  const color = compGroupData.color ?? generateColorFromString(compGroupData.name);
  const tooltipContent = useMemo(() => getCompGroupTooltipContent(compGroupData), [compGroupData]);

  const handleClick = (): void => {
    setOpenCompGroupsDialog(true);
    if (setCompanyInfoHovering) {
      setCompanyInfoHovering(false);
    }
  };

  const handleOnMouseEnter = (): void => {
    if (setCompanyInfoHovering) {
      setCompanyInfoHovering(false);
    }
  };

  const handleOnMouseLeave = (): void => {
    if (setCompanyInfoHovering) {
      setCompanyInfoHovering(true);
    }
  };

  const compGroupLabel = compGroupData?.id ? getInitials({ name: compGroupData.name }) : null;

  return (
    <Root color={color} onMouseEnter={handleOnMouseEnter} onMouseLeave={handleOnMouseLeave}>
      <Tooltip
        placement="top"
        arrow
        describeChild
        title={
          <Box sx={{ textAlign: 'left' }}>
            <Box component="span" sx={{ display: 'block', whiteSpace: 'nowrap' }}>
              {tooltipContent.name}
            </Box>
            {tooltipContent.automaticUpdatesLabel && (
              <Box component="span" sx={{ display: 'block' }}>
                {tooltipContent.automaticUpdatesLabel}
              </Box>
            )}
          </Box>
        }>
        <button type="button" onClick={handleClick} className={compGroupLabelClasses.compGroupLabelInitials}>
          <span>{compGroupLabel}</span>
        </button>
      </Tooltip>
      {openCompGroupsDialog && (
        <CompGroupsDialog
          openCompGroupsDialog
          setOpenCompGroupsDialog={setOpenCompGroupsDialog}
          saveCompGroups={saveCompGroups}
          deleteCompGroup={deleteCompGroup}
          tableData={tableData}
          approachType={approachType}
          defaultCompGroupId={compGroupData.id}
        />
      )}
    </Root>
  );
};

export default CompGroupLabel;
